import { useForBinding } from '@practium/features/forBinding';
import { usePermissions } from '@practium/features/permissions';
import { MaintenanceWorkspacePage, WORKSPACE_TABS } from '@practium/features/recommendations';
import type { MaintenanceWorkspaceTab } from '@practium/features/recommendations';
import { LoadingState } from '@practium/ui';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getRecommendationsListPath } from '../routes';
import {
	useDeleteAdviceMaintenance,
	useGetAdviceMaintenanceById,
} from '@practium/features/api';

export const ViewMaintenanceAdvicePageClient = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const id = searchParams.get('id') || '';
	const tabParam = searchParams.get('tab');
	const initialTab = WORKSPACE_TABS.find((tab) => tab.key === tabParam)?.key;
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();
	const subject = isForBinding ? 'farmers-recommendations' : 'recommendations';
	const { data: advice, isLoading } = useGetAdviceMaintenanceById(id);
	const { mutateAsync: deleteMaintenanceAdvice } = useDeleteAdviceMaintenance();

	const canEdit = abilities.can('update', subject);

	const canDelete = abilities.can('delete', subject);

	if (!advice || isLoading) return <LoadingState />;

	const handleDelete = async () => {
		await deleteMaintenanceAdvice(id);
		navigate(getRecommendationsListPath('maintenance'));
	};

	const handleEdit = () => navigate(`/recomendacoes/manutencao/editar?id=${id}`);

	const handleTabChange = (tab: MaintenanceWorkspaceTab) =>
		setSearchParams({ id, tab }, { replace: true });

	return (
		<MaintenanceWorkspacePage
			viewData={advice}
			onBack={() => navigate(getRecommendationsListPath('maintenance'))}
			onEdit={canEdit ? handleEdit : undefined}
			onDelete={canDelete ? handleDelete : undefined}
			initialTab={initialTab}
			onTabChange={handleTabChange}
		/>
	);
};
